import { render, staticRenderFns } from "./RecentActivityCard.vue?vue&type=template&id=5fa395fb&scoped=true"
import script from "./RecentActivityCard.vue?vue&type=script&lang=js"
export * from "./RecentActivityCard.vue?vue&type=script&lang=js"
import style0 from "./RecentActivityCard.vue?vue&type=style&index=0&id=5fa395fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa395fb",
  null
  
)

export default component.exports